import React from "react";
import { Sort } from "../../assets";
import "./SortIcon.scss";

const SortIcon = ({ onClick }: any) => {
  return <img className="sort-icon" src={Sort} onClick={onClick} />;
};

export default SortIcon;
